import api from '@stencil/megatron/src/api';

import {getDeviceID, getMAPIBaseUrl} from '@stencil/hotels-utils/src/common-utils';
import {getDeviceDetail, getSearchCriteria, getRequestDetails} from './apiUtils';
import {SEARCH_ROOM_BASE_URL, CART_UPDATE_PRICE_BASE_URL} from './apiUrls';
import {getExperimentData} from '@stencil/hotels-utils/src/get-experiment-data';

export const prepareCartUpdatePriceRequest = requestObj => {
  const {
    urlParams,
    pokus,
    selectedCurrency,
    requiredFlags,
    travellerEmailId,
    flavour,
    roomCriteria,
    searchType,
    payMode,
  } = requestObj;
  const isDesktop = flavour === 'desktop';
  return {
    deviceDetails: getDeviceDetail(isDesktop),
    searchCriteria: getSearchCriteria({
      urlParams,
      selectedCurrency,
      travellerEmailId,
      roomCriteria,
      searchType,
    }),
    requestDetails: getRequestDetails({urlParams, paymentMode: payMode}),
    expData: getExperimentData({pokus}),
  };
};

export const fetchCartUpdatePriceData = async (requestObj, client = 'DESKTOP') => {
  const searchRoomsRequestObj = prepareCartUpdatePriceRequest(requestObj);

  return await api.post(
    getMAPIBaseUrl(),
    CART_UPDATE_PRICE_BASE_URL.replace(':client', client),
    searchRoomsRequestObj,
    true,
  );
};
